import React, { useEffect, useState, useRef, useCallback } from 'react';
import { Link, useParams, useNavigate, useLocation } from 'react-router-dom';
import Select from 'react-select';
import Scroller from 'ui-component/Scroller';
import moment from 'moment';
import { useSelector, useDispatch } from 'react-redux';
import { setReturncomponent } from 'store/reducers/mainSlice';
import 'react-datepicker/dist/react-datepicker.css';
import { FaPlus, FaSave, FaSpinner } from 'react-icons/fa';
import { toast } from 'react-hot-toast';
import { Modal } from 'react-bootstrap';
import { TbDatabaseExclamation } from 'react-icons/tb';
import PermissionAllowed from 'ui-component/permissions/PermissionAllowed';
import { Skeleton, Tooltip } from '@mui/material';
import { CgNotes } from 'react-icons/cg';
import { IoIosArrowDown } from 'react-icons/io';
import { ImSpinner2 } from 'react-icons/im';
import usePageTitle from 'hooks/usePageTitle';
import ProductList from './components/ProductList';
import { IoIosClose } from 'react-icons/io';
import { SelectionProvider } from './components/SelectionContext';
import ReactSelect from 'react-select';
import { flexbox } from '@mui/system';
import NoImage from 'assets/images/no-image.png';
import ReactSelectCreatable from 'react-select/creatable';

import InputGroup from 'react-bootstrap/InputGroup';
import DropdownButton from 'react-bootstrap/DropdownButton';
import PurchaseOrderProductsModal from './components/PurchaseOrderProductsModal';
import DeleteConfirmation from 'ui-component/confirmation-dialogs/deleteConfirmation/DeleteConfirmation';
import MentionInput from 'ui-component/MentionInput/MentionInput';
import useIsMobile from 'utils/isMobileUtils';
import { FiTrash2 } from 'react-icons/fi';
import { useDropzone } from 'react-dropzone';
import PdfViewer from 'ui-component/PdfViewer';
import { ChevronLeftIcon, PlusIcon, InfoIcon } from 'ui-component/custom-icons/icons';


const PurchasingForm = ({ edit }) => {
    const location = useLocation();
	const { id } = useParams();
    const params = new URLSearchParams(location.search);
    const productData = JSON.parse(decodeURIComponent(params.get('data')));

    const [setPageTitle] = usePageTitle(`${edit ? 'Edit' : 'New'} Purchase order`);
    useEffect(() => {
        return () => {
            setPageTitle(null);
        };
    }, []);

    const [isInternalLoading, setInternalLoading] = useState(true);
    const history = useNavigate();
    const currencies = [
        { label: 'EUR', value: 'eur' },
        { label: 'USD', value: 'usd' },
        { label: 'AED', value: 'aed' }
    ];
    const paymentMethods = [
        { label: 'In Credit', value: 'in_credit' },
        { label: 'Upfront Payment', value: 'upfront_payment' }
    ];
    const [defaultCurrency, setDefaultCurrency] = useState('eur');

    const [selectedRowsData, setSelectedRowsData] = useState([]);
    const [openPopup, setOpenPopup] = useState(false);
    const [hasProducts, setHasProducts] = useState(false);
    const [isSaveButtonDisabled, setIsSaveButtonDisabled] = useState(false);
    const [supplierList, setsupplierList] = useState([]);
    const [gradesLists, setGradesLists] = useState([]);
    const [warehouseList, setwarehouseList] = useState([]);
    const [salesOrderList, setSalesOrderList] = useState([]);
    const [totalQuantity, setTotalQuantity] = useState(0);
    const [totalPrice, setTotalPrice] = useState(0);
    const currentDate = moment().format('YYYY-MM-DD');
    const [alertMessage, setAlertMessage] = useState();
    const [convertedTotalPrice, setConvertedTotalPrice] = useState({ 'usd': 0, 'eur': 0, 'aed': 0 });
    const [currency, setCurrency] = useState('');
    const textareaRef = useRef(null);
	const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [selectedProductToDelete, setSelectedProductToDelete] = useState(null);
	const [disableForm, setDisableForm] = useState(true);
	const [inputFocus, setInputFocus] = useState(false);
	const [products, setProducts] = useState([]);
	const [noteInputPlain, setNoteInputPlain] = useState('');
	const [noteMentions, setNoteMentions] = useState([]);
	const [newFormVersion, setNewFormVersion] = useState(false);
	const [isProductsLoading, setIsProductsLoading] = useState(true);
	const [showAttachmentActions, setShowAttachmentActions] = useState(false);
	
	const [showDeleteAttachment, setShowDeleteAttachment] = useState(false);

    const [purchaseOrder, setPurchaseOrder] = useState({
        id: '',
		referenceNo: [],
		purchaseInvoiceNumber: '',
        purchaseOrderId: '',
        supplierId: '',
        expectedDate: currentDate,
        warehouseId: '',
        currency: 'usd',
        paymentMethod: 'upfront_payment',
        shippingFee: '0.00',
        taxAmount: '0.00',
        notes: '',
		attachmentId: '',
		attachmentUrl: '',
		attachmentExtension: '',
        purchaseInvoiceDetails: []
    });
    const handlePurchaseOrderInfo = (val) => {
        setPurchaseOrder(val);
    };

  
	useEffect(() => {
		// initiateData();
		loadProducts();
	}, []);
  
	const loadProducts = async () => {
		setIsProductsLoading(true)
		api.getSelectOptionsList('purchase_order_products').then((res) => {
			const tempList = res.data.map((item) => ({
				...item,
				label: `${item.option_product_name}`,
				value: item.id,
			}));
			setProducts(tempList);
			setIsProductsLoading(false);
			setDisableForm(false);
			// setIsProductsLoaded(true)
		});
	}


    
    const [purchaseList, setPurchaseList] = useState({
        supplier_id: '',
        warehouse_id: '',
        expectedDate: currentDate,
        invoiceNumber: '',
        currency: 'eur'
    });
    // Row Area
    const [rows, setRows] = useState([{ id: 1, modelId: '', type: '', quantity: 0, unitPrice: 0, total: 0, comment: '' }]);

    useEffect(() => {
        if (selectedRowsData.length === 0) {
            if (productData?.length > 0) {
                const allOrders = productData.flatMap((product) => product);
                setSelectedRowsData(allOrders);
            }
        }
    }, [productData]);
    useEffect(() => {
        if (selectedRowsData && selectedRowsData.length > 0) {
            const calculatedTotalQuantity = selectedRowsData.reduce((total, row) => total + row.quantity, 0);
            setTotalQuantity(calculatedTotalQuantity);

            const calculatedTotalPrice = selectedRowsData.reduce((total, row) => total + row.quantity * row.price, 0);
            setTotalPrice(calculatedTotalPrice);
        } else {
            setTotalQuantity(0);
            setTotalPrice(0);
        }
	}, [selectedRowsData]);
	

    const handleDoneClick = (data) => {
        // return false;
        closeFound(data);
        setHasProducts(true)
        // setSelectedRowsData((prevData) => [...prevData, ...data]);


        const modifiedData = data?.map((item) => {
            return {
                currency: item?.currency,
                free_stock: item?.free_stock,
                is_selected: item?.is_selected,
                price: item?.price,
                product_id: item?.product_id,
                product_name: item?.product_name,
                quantity: item?.quantity,
                reserved_stock: item?.reserved_stock,
                purchased_quantity: item?.purchased_quantity,
                sku: item?.sku,
                thumbnail_url: item?.thumbnail_url,
                converted_currency_price: item?.converted_currency_price,
                id: item?.id,
                // converted_currency_total: item?.converted_currency_total

                converted_currency_total: {
                    'usd': item?.converted_currency_price['usd'] * item?.quantity,
                    'eur': item?.converted_currency_price['eur'] * item?.quantity,
                    'aed': item?.converted_currency_price['aed'] * item?.quantity,
                }
            }
        });
        setConvertedTotalPrice({
            'usd': modifiedData.reduce((accumulator, currentItem) => { return accumulator + currentItem.converted_currency_total['usd']; }, 0),
            'eur': modifiedData.reduce((accumulator, currentItem) => { return accumulator + currentItem.converted_currency_total['eur']; }, 0),
            'aed': modifiedData.reduce((accumulator, currentItem) => { return accumulator + currentItem.converted_currency_total['aed']; }, 0)
        })
        setSelectedRowsData(modifiedData);
    };

    const handleextimatevalue = (val) => {
        setPurchaseList(val);
    };

    const handleSelectRow = () => {
        setOpenPopup(true);
        // setPurcahseListId(purchase_list_id);
    };
    const closeFound = (data) => {
        if (data == 'reload') {
            setOpenPopup(false);
            // setPurcahseListId(null);
            // this.forceUpdate();
        } else {
            setOpenPopup(false);
            // setPurcahseListId(null);
        }
    };

    useEffect(() => {
        setPurchaseList({
            supplier_id: '',
            warehouse_id: '',
            expectedDate: currentDate
        });
        setRows([{ id: 1, modelId: '', type: '', quantity: 0, unitPrice: 0, total: 0, comment: '' }]);
        initiateDatas();
    }, [edit]);

    const [loaderStatus, setLoaderStatus] = useState({
        suppliers: false,
        warehouse: false,
        sales_orders: false
    });


    const initiateDatas = () => {
        
		api.getSelectOptionsList('warehouse').then((res) => {
			const customerArray = res?.data?.map((item) => ({ id: item.id, label: item.name, value: item.id }));
			setwarehouseList(customerArray);
			setLoaderStatus((oldData) => ({
				...oldData,
				warehouse: false
			}));
			if (purchaseOrder?.warehouseId === '') {

				setPurchaseOrder((oldData => ({
					...oldData,
					warehouseId: customerArray?.[0]?.id || ''
				})));
			}
		});
        api.getSelectOptionsList('supplier').then((res) => {
            const customerArray = res?.data?.map((item) => ({ id: item.id, label: item.name, value: item.id }));
            setsupplierList(customerArray);
            setLoaderStatus((oldData) => ({
                ...oldData,
                suppliers: false
            }));
        });
        // api.getSelectOptionsList('sales_order').then((res) => {
        //     const collection = res?.data?.map((item) => ({ id: item.id, label: item.sales_order_number, value: item.id }));
        //     setSalesOrderList(collection);
        //     setLoaderStatus((oldData) => ({
        //         ...oldData,
        //         sales_orders: false
        //     }));
        // });
		// api.getSelectOptionsList('grade').then((res) => {
		// 	const tempList = res.data.map((item) => ({
		// 		...item,
		// 		label: `${item.name}`,
		// 		value: item.id,
		// 	}));
		// 	setGradesLists(tempList);
		// 	// setIsProductsLoaded(true)
		// });
        setInternalLoading(false)
        if (edit)
        {
            api.getPurchaseOrderDetails(id).then((res) => {

                const purchaseOrderDetails = res?.data?.purchase_invoice_details?.map((item) => {
                    return {
                        label: item?.reference_no,
                        value: item?.sales_order_id
                    }
                })
                setPurchaseOrder({
                    ...purchaseOrder,
                    id: res?.data?.id,
                    referenceNo: res?.data?.reference_no,
                    purchaseInvoiceNumber: res?.data?.purchase_invoice_number,
                    purchaseOrderId: res?.data?.purchase_order_id,
                    supplierId: res?.data?.supplier?.id,
                    expectedDate: res?.data?.date,
                    warehouseId: res?.data?.warehouse?.id,
                    currency: res?.data?.currency,
                    paymentMethod: res?.data?.payment_method,
                    shippingFee: res?.data?.shipping_fee,
                    notes: res?.data?.notes,
					purchaseInvoiceDetails: purchaseOrderDetails,
					newVersion: res?.data?.has_same_multiple_products ? true : false,
					attachmentId: res?.data?.default_attachment?.id,
					attachmentUrl: res?.data?.default_attachment?.url,
					attachmentExtension: res?.data?.default_attachment?.extension,
                });
                setNewFormVersion(res?.data?.has_same_multiple_products ? true : false);
                setCurrency(res?.data?.currency);

                const modifiedData = res?.data?.purchase_invoice_items?.map((item) => {
                    return {
                        converted_currency_total: {
                            'usd': item?.converted_currency_price['usd'] * item?.quantity,
                            'eur': item?.converted_currency_price['eur'] * item?.quantity,
                            'aed': item?.converted_currency_price['aed'] * item?.quantity,
                        }
                    }
                });
                setConvertedTotalPrice({
                    'usd': modifiedData.reduce((accumulator, currentItem) => { return accumulator + currentItem.converted_currency_total['usd']; }, 0),
                    'eur': modifiedData.reduce((accumulator, currentItem) => { return accumulator + currentItem.converted_currency_total['eur']; }, 0),
                    'aed': modifiedData.reduce((accumulator, currentItem) => { return accumulator + currentItem.converted_currency_total['aed']; }, 0)
				})

				if (res?.data?.purchase_invoice_items.length > 0) {
					setHasProducts(true)
							
						const items = res?.data?.purchase_invoice_items?.map(item => {

							const currency = res?.data?.currency;
							const purchasePrice = item?.price !== '0.00' ? item?.price : '0.00';
							setIsSaveButtonDisabled(false)
							setInternalLoading(false)
							return {
								currency: currency,
								free_stock: item?.product?.available_quantity,
								id: item?.id,
								price: item?.price,
								product_id: item?.product?.id,
								product_name: item?.product?.name,
								quantity: item?.quantity,
								colors: item?.colors,
								model: item?.model,
								reserved_stock: 0, //item?.reserved_stock,
								purchased_quantity: item?.quantity,
								sku: item?.product?.sku,
								thumbnailUrl: item?.product?.thumbnail_url,
								converted_currency_price: item?.converted_currency_price,
								selectedColorId: item?.selectedColorId,
								selectedColorName: item?.selectedColorName,
								converted_currency_total: {
									'usd': item?.converted_currency_price['usd'] * item?.quantity,
									'eur': item?.converted_currency_price['eur'] * item?.quantity,
									'aed': item?.converted_currency_price['aed'] * item?.quantity,
								},
								is_selected: true,
							}
						});
						setSelectedRowsData(items);
				}
            });
        }
    };



    const removeRow = (id, productId) => {
        if (id) {
            setShowDeleteModal(true)
            setSelectedProductToDelete(id)
        } else {
            const updatedRows = selectedRowsData.filter((row) => row.product_id !== productId);
            setConvertedTotalPrice({
                'usd': updatedRows.reduce((accumulator, currentItem) => { return accumulator + currentItem.converted_currency_total['usd']; }, 0),
                'eur': updatedRows.reduce((accumulator, currentItem) => { return accumulator + currentItem.converted_currency_total['eur']; }, 0),
                'aed': updatedRows.reduce((accumulator, currentItem) => { return accumulator + currentItem.converted_currency_total['aed']; }, 0)
            })
            setSelectedRowsData(updatedRows);
            if (updatedRows.length < 1) {
                setHasProducts(false);
            }
        }
    };


	const handleClose = () => {
		setShowDeleteModal(false);
		setShowDeleteAttachment(false);
	}

    const handleDelete = async () => {
        // selectedProductToDelete
        // setShowDeleteModal(false)


        toast.promise(
            api.deletePurchasingProduct(selectedProductToDelete).then((res) => {
                if (res.status) {
                    setSelectedProductToDelete(null);
                    setShowDeleteModal(false)

                const updatedRows = selectedRowsData.filter((row) => row.id !== selectedProductToDelete);
                setConvertedTotalPrice({
                    'usd': updatedRows.reduce((accumulator, currentItem) => { return accumulator + currentItem.converted_currency_total['usd']; }, 0),
                    'eur': updatedRows.reduce((accumulator, currentItem) => { return accumulator + currentItem.converted_currency_total['eur']; }, 0),
                    'aed': updatedRows.reduce((accumulator, currentItem) => { return accumulator + currentItem.converted_currency_total['aed']; }, 0)
                })
                setSelectedRowsData(updatedRows);
                if (updatedRows.length < 1) {
                    setHasProducts(false);
                }
                }
                return res?.status ? res : abc;
            }),
            {
                loading: 'Removing product...',
                success: (data) => `${data.message}`,
                error: <b>Failed to remove product</b>
            }
        );


        // setSelectedProductToDelete(id)
	}
	
    const handleQuantityChange = (index, value) => {

        const collections = [...selectedRowsData];
        const enteredQty = parseFloat(value);
        // const itemIndex = collections.findIndex(product => product.product_id === id);
        const selectedCurrentConvertedPrice = {
            'usd': parseFloat(collections[index].converted_currency_price['usd']),
            'eur': parseFloat(collections[index].converted_currency_price['eur']),
            'aed': parseFloat(collections[index].converted_currency_price['aed']),
        }

        if (!isNaN(enteredQty)) {
            collections[index].quantity = enteredQty;

            collections[index].converted_currency_total = {
                'usd': parseFloat(selectedCurrentConvertedPrice['usd']) * parseInt(collections[index].quantity),
                'eur': parseFloat(selectedCurrentConvertedPrice['usd']) * parseInt(collections[index].quantity),
                'aed': parseFloat(selectedCurrentConvertedPrice['usd']) * parseInt(collections[index].quantity),
            };
        } else {
            collections[index].quantity = 0;

            collections[index].converted_currency_total = {
                'usd': parseFloat(selectedCurrentConvertedPrice['usd']) * parseInt(0),
                'eur': parseFloat(selectedCurrentConvertedPrice['usd']) * parseInt(0),
                'aed': parseFloat(selectedCurrentConvertedPrice['usd']) * parseInt(0),
            };
        }

        setConvertedTotalPrice({
            'usd': collections.reduce((accumulator, currentItem) => { return accumulator + currentItem.converted_currency_total['usd']; }, 0),
            'eur': collections.reduce((accumulator, currentItem) => { return accumulator + currentItem.converted_currency_total['eur']; }, 0),
            'aed': collections.reduce((accumulator, currentItem) => { return accumulator + currentItem.converted_currency_total['aed']; }, 0)
        })
        setSelectedRowsData(collections);
	};
	

    const handleChangeCurrency = (value) => {
        setPurchaseOrder({
            ...purchaseOrder,
            currency: value, // Update the currency value
        });
    }
	const handleUnitPriceChange = (index, value) => {

		const collections = [...selectedRowsData];
		const enteredQty = parseFloat(value);
		// const itemIndex = collections.findIndex(product => product.product_id === id);
		const rowCurrency = purchaseOrder?.currency;

		if (!isNaN(enteredQty)) {

			collections[index].converted_currency_price = {
				'usd': parseFloat(enteredQty),
				'eur': parseFloat(enteredQty),
				'aed': parseFloat(enteredQty),
			};
			collections[index].converted_currency_total = {
				'usd': parseFloat(enteredQty) * parseInt(collections[index].quantity),
				'eur': parseFloat(enteredQty) * parseInt(collections[index].quantity),
				'aed': parseFloat(enteredQty) * parseInt(collections[index].quantity),
			};


		} else {
			collections[index].converted_currency_price = {
				'usd': parseFloat(0),
				'eur': parseFloat(0),
				'aed': parseFloat(0),
			};
			collections[index].converted_currency_total = {
				'usd': parseFloat(0) * parseInt(collections[index].quantity),
				'eur': parseFloat(0) * parseInt(collections[index].quantity),
				'aed': parseFloat(0) * parseInt(collections[index].quantity),
			};
		}
		collections[index].price = enteredQty;
		setConvertedTotalPrice({
			'usd': collections.reduce((accumulator, currentItem) => { return accumulator + currentItem.converted_currency_total['usd']; }, 0),
			'eur': collections.reduce((accumulator, currentItem) => { return accumulator + currentItem.converted_currency_total['eur']; }, 0),
			'aed': collections.reduce((accumulator, currentItem) => { return accumulator + currentItem.converted_currency_total['aed']; }, 0)
		})
		setSelectedRowsData(collections);
	};
	
    const validateRows = () => {
        for (let i = 0; i < selectedRowsData.length; i++) {
            const { product_id, quantity, price } = selectedRowsData[i];
            if (i != selectedRowsData.length - 1) {
                if (!product_id || !quantity || !price) {
                    return false;
                }
            }
        }
        return true;
    };

    const closePopup = () => {
        setOpenPopup(false);
    };
    const formValidation = () => {
        let isValid = true;
        if (typeof purchaseOrder?.referenceNo?.length < 1) {
            isValid = false;
            toast.error('Reference number is required');
        } else if (typeof purchaseOrder?.supplierId === 'undefined' || purchaseOrder?.supplierId == '') {
            isValid = false;
            toast.error('Supplier is required');
        } else if (typeof purchaseOrder?.expectedDate === 'undefined' || purchaseOrder?.expectedDate == '') {
            isValid = false;
            toast.error('Purchase Date is required');
        } else if (typeof purchaseOrder?.warehouseId === 'undefined' || purchaseOrder?.warehouseId == '') {
            isValid = false;
            toast.error(typeof purchaseOrder?.warehouseId === 'undefined' || 'Warehouse is required');
        } else if (typeof purchaseOrder?.currency === 'undefined' || purchaseOrder?.currency == '') {
            isValid = false;
            toast.error('Currency is required');
        } else if (typeof purchaseOrder?.paymentMethod === 'undefined' || purchaseOrder?.paymentMethod == '') {
            isValid = false;
            toast.error('Payment method is required');
        // } else if (selectedRowsData.length < 1) {
        //     isValid = false;
        //     toast.error('Please add at least one product');
        // } else if (!validateRows()) {
        //     isValid = false;
        //     toast.error('Please fill in all fields for each product');
        }

        return isValid;
    };

    const updateSubmit = () => { 
        if (formValidation()) {
            const data = {
                ...purchaseOrder,
                products: selectedRowsData,
				purchase_invoice_number: purchaseOrder?.purchaseInvoiceNumber,
                reference_no: purchaseOrder?.referenceNo,
                supplier_id: purchaseOrder?.supplierId,
                expected_date: purchaseOrder?.expectedDate,
                warehouse_id: purchaseOrder?.warehouseId,
                shipping_fee: purchaseOrder?.shippingFee,
                currency: purchaseOrder?.currency ? purchaseOrder?.currency : 'eur',
				payment_method: purchaseOrder?.paymentMethod,
				attachment_id: purchaseOrder?.attachmentId,
                notes: purchaseOrder?.notes,
                purchase_invoice_details: purchaseOrder?.purchaseInvoiceDetails
                // invoiceNumber: purchaseList?.invoiceNumber,
            };
            setIsSaveButtonDisabled(true);
            api.updatePurchaseOrder(id, data).then(
                (res) => {
                    if (res.status) {
                        toast.success(res.message);
                        history(`/purchasing/view/${id}`);
                    } else {
                        toast.error(res.message);
                    }
                    setIsSaveButtonDisabled(false);
                },
                () => { }
            );
        }
    };

	const savePurchaseOrder = () => {
		const data = {
			...purchaseOrder,
			products: selectedRowsData,
			purchase_invoice_number: purchaseOrder?.purchaseInvoiceNumber,
			reference_no: purchaseOrder?.referenceNo,
			supplier_id: purchaseOrder?.supplierId,
			expected_date: purchaseOrder?.expectedDate,
			warehouse_id: purchaseOrder?.warehouseId,
			shipping_fee: purchaseOrder?.shippingFee,
			currency: purchaseOrder?.currency ? purchaseOrder?.currency : 'eur',
			payment_method: purchaseOrder?.paymentMethod,
			attachment_id: purchaseOrder?.attachmentId,
			notes: purchaseOrder?.notes,
			newVersion: newFormVersion,
			// invoiceNumber: purchaseList?.invoiceNumber,
		};
		if (formValidation()) {
            setIsSaveButtonDisabled(true);
            api.postPurchaseOrder(data).then(
                (res) => {
                    if (res.status) {
                        toast.success(res.message);
                        history(`/purchasing/view/${res.data.id}`);
                    } else {
                        toast.error(res.message);
                    }
                    setIsSaveButtonDisabled(false);
                },
                () => { }
            );
		}
    };

	const [clearInput, setClearInput] = useState(false);

	const clearInputField = () => {
		setClearInput(true);
		setTimeout(() => {
			setClearInput(false);
		}, 1);
	};


	// const [preloadedSelectionsProdModals, setPreloadedSelectionsProdModals] = useState(null);
	const [productsData, setProductsData] = useState([]);
	const handleProductSubmit = (data) => {
		setProductsData(data?.dataItems);
		if (data?.dataItems?.length > 0) {
			setHasProducts(true);
		}
		setNewFormVersion(true);
		setOpenPopup(false);


        const modifiedData = data?.dataItems?.map((item) => {
            return {
                currency: purchaseOrder?.currency,
                // free_stock: item?.free_stock,
                // is_selected: item?.is_selected,
                price: item?.price,
                product_id: item?.model?.id,
                product_name: item?.model?.product_name,
                quantity: item?.quantity,
                // reserved_stock: item?.reserved_stock,
				purchased_quantity: item?.quantity,
				model: item?.model,
				

				model: item?.model,
				colors: item?.colors,
				selectedColorId: item?.selectedColorId,
				selectedColorName: item?.selectedColorName,

                sku: item?.sku,
                thumbnailUrl: item?.thumbnailUrl,
                // customThumbnailUrl: item?.customThumbnailUrl,
                // converted_currency_price: item?.converted_currency_price,
                converted_currency_price: {
                    'usd': item?.price,
                    'eur': item?.price,
                    'aed': item?.price,
                },
                id: item?.id,
                // converted_currency_total: item?.converted_currency_total

                converted_currency_total: {
                    'usd': item?.price * item?.quantity,
                    'eur': item?.price * item?.quantity,
                    'aed': item?.price * item?.quantity,
                }
            }
        });
        setConvertedTotalPrice({
            'usd': modifiedData.reduce((accumulator, currentItem) => { return accumulator + currentItem.converted_currency_total['usd']; }, 0),
            'eur': modifiedData.reduce((accumulator, currentItem) => { return accumulator + currentItem.converted_currency_total['eur']; }, 0),
            'aed': modifiedData.reduce((accumulator, currentItem) => { return accumulator + currentItem.converted_currency_total['aed']; }, 0)
        })
        setSelectedRowsData(modifiedData);


	};

	const [attachmentPreviewDetails, setAttachmentPreviewDetails] = useState({
		showPreview: false,
		url: '',
		extension: ''
	});


	const allowedExtensions = ['pdf', 'jpeg', 'jpg', 'png'];
	const validateFileExtension = (fileName) => {
		const extension = fileName.split('.').pop().toLowerCase();
		return allowedExtensions.includes(extension);
	};


	const uploadAttachment = async (attachment) => {
		const formData = new FormData();
		formData.append('attachment', attachment);
		formData.append('purchase_invoice_id', purchaseOrder?.id);
		formData.append('type', 'other');
		try {

			toast.promise(
				api
					.uploadPurchaseInvoiceAttachment(formData)
					.then(
						(res) => {
							if (!res.status) {
								toast.error(`Uploading attachment failed. Please try again.`);
							} else {
								setPurchaseOrder((oldData) => ({
									...oldData,
									attachmentId: res?.data?.attachment_id || '',
									attachmentUrl: res?.data?.attachment_url || '',
									attachmentExtension: res?.data?.attachment_extension || '',
								}));
							}

							return res?.status ? res : null;
						},
						() => {}
					),
				{
					loading: 'uploading file...',
					success: (data) => `${data.message}`,
					error: <b>Failed to upload file</b>
				}
			);
			
		} catch (error) {
			toast.error('Error uploading file');
		}
	};

    const removeAttachment = (id) => {
        setShowDeleteAttachment(true);
	}
	
	const handleDeleteAttachment = () => {
		if (purchaseOrder?.id) {
			const id = purchaseOrder?.attachmentId;
			api.deletePurchaseOrderAttachment(id).then((res) => {
				setShowDeleteAttachment(false);
				if (res.status) {
					setPurchaseOrder((oldData) => ({
						...oldData,
						attachmentId: '',
						attachmentUrl: '',
						attachmentExtension: '',
					}));
					toast.success(res.message);
					// initiate();
				} else {
					toast.error(res.message);
				}
			});
		} else {

			setPurchaseOrder((oldData) => ({
				...oldData,
				attachmentId: '',
				attachmentUrl: '',
				attachmentExtension: '',
			}));
			toast.success('Attachment removed successfully');
			setShowDeleteAttachment(false);
		}
	}

	const [isDragActive, setIsDragActive] = useState(false);

	const onAttachmentDrop = useCallback((acceptedFiles) => {

			const file = acceptedFiles[0];
			if (!file) return;
	
			if (!validateFileExtension(file.name)) {
				toast.error('Invalid file extension. Please select a PDF, JPEG, JPG, or PNG file.');
				return;
			}
	
			if (file.size > 5 * 1024 * 1024) {
				toast.error('File size should not exceed more than 5MB.');
				return;
			}
			let sizeStr = '';
			if (file.size >= 1024 * 1024) {
				sizeStr = (file.size / (1024 * 1024)).toFixed(2) + ' MB';
			} else {
				sizeStr = (file.size / 1024).toFixed(2) + ' KB';
			}
			// let values = {
			// 	filename: file.name,
			// 	size: sizeStr,
			// 	extension: file.type,
			// }
	
			// setInProgressFileUploadCollection((oldData) => [...oldData, values]);
	
			uploadAttachment(file);
		
		
		// if (validateFileExtension(acceptedFiles[0].name)) {
		// 	uploadAttachment(acceptedFiles[0]);
		// 	// setPaymentData((prevData) => ({ ...prevData, attachment: acceptedFiles[0] }));
		// 	// setPaymentAttachment(acceptedFiles[0].name);
		// } else {
		// 	toast.error('Invalid file extension. Please select a PDF, JPEG, JPG, or PNG file.');
		// }
	}, [purchaseOrder]);

	// const { getRootProps: getAttachmentRootProps, getInputProps: getAttachmentInputProps } = useDropzone({ onDrop: onAttachmentDrop });
	const {
		getRootProps: getAttachmentRootProps,
		getInputProps: getAttachmentInputProps,
		isDragActive: dropzoneDragActive,
	} = useDropzone({
		onDrop: onAttachmentDrop,
		onDragEnter: () => setIsDragActive(true),
		onDragLeave: () => setIsDragActive(false),
		onDragOver: () => setIsDragActive(true),
		onDropAccepted: () => setIsDragActive(false),
		onDropRejected: () => setIsDragActive(false),
	});


    const isMobile = useIsMobile();
    return (
			<>
				<div className="row m-0 w-100" style={{ marginTop: '20px' }}>
					<div className={`col-12 col-md-12 ${isMobile ? 'p-0' : ''}`}>
						<div className="show-on-mobile new-page-header" style={{ position: 'relative' }}>
							<div className="header-bubble" />
							<div className="d-flex flex-column gap-2 " style={{ position: 'relative', zIndex: 1, paddingTop: 10, width: '100%' }}>
								<div
									style={{
										position: 'relative',
										display: 'flex',
										alignItems: 'center',
										justifyContent: 'center',
										marginBottom: 8,
										minHeight: 38 // ensures enough height for the button
									}}
								>
									{' '}
									<button
										type="button"
										aria-label="Back"
										onClick={() => history(-1)}
										className="circle-back-btn"
										style={{
											position: 'absolute',
											left: 20,
											top: '50%',
											transform: 'translateY(-50%)'
										}}
									>
										{/* Replace with your fi arrow icon, example below */}
										<svg width="22" height="22" fill="none" viewBox="0 0 24 24">
											<path d="M15 19l-7-7 7-7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
										</svg>
									</button>
									<h5 style={{ textAlign: 'center', flex: 1, margin: 0 }}>
										{' '}
										{edit ? purchaseOrder?.purchaseOrderId : 'New Purchase Order'}
									</h5>
								</div>
								<div style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
									{
										disableForm ? (
											<>
												<div style={{ width: '100px' }}>
													<Skeleton variant="rounded" width={'100%'} height={30} style={{ borderRadius: '8px' }} />
												</div>
											</>
										) : (
											<>

												{!edit ? (
													<>
														<PermissionAllowed permissions={['Create Purchase Order']}>
															<button
																type="button"
																onClick={() => savePurchaseOrder()}
																className="btn btn-primary btn-outlined-main"
																disabled={isInternalLoading || isSaveButtonDisabled}
															>
																{isSaveButtonDisabled ? (
																	<>
																		<FaSpinner className="fa-spin" /> Saving...
																	</>
																) : (
																	<>
																		<FaSave /> Save
																	</>
																)}
															</button>
														</PermissionAllowed>
													</>
												) : (
													<PermissionAllowed permissions={['Edit Purchase Order']}>
														<button
															type="button"
															onClick={() => updateSubmit()}
															className="btn btn-primary btn-outlined-main"
															disabled={isInternalLoading || isSaveButtonDisabled}
														>
															{isSaveButtonDisabled ? (
																<>
																	<FaSpinner className="fa-spin" /> Updating...
																</>
															) : (
																<>
																	<FaSave /> Update
																</>
															)}
														</button>
													</PermissionAllowed>
												)}
											</>
										)
									}
								</div>
							</div>
						</div>
						<div className="section-head hide-on-mobile">
							<h2 style={{ display: 'flex', alignItems: 'center', gap: '5px', fontSize: '18px', marginLeft: '-10px', marginTop: '-5px' }}>
								{/* {edit && purchaseOrder?.purchaseOrderId} */}
								{edit && (
									<button
										type="button"
										className="btn btn-primary btn-outlined-main white-var"
										style={{ minWidth: 'unset' }}
										onClick={() => {
											history(`/purchasing/view/${id}`);
										}}
									>
										<ChevronLeftIcon /> Back to Preview
									</button>
								)}
							</h2>
							<div className="actions">
								{
									disableForm ? (
										<>
											<div style={{ width: '100px' }}>
												<Skeleton variant="rounded" width={'100%'} height={30} style={{ borderRadius: '8px' }} />
											</div>
										</>
									) : (
										<>
											{!edit ? (
												<>
													<PermissionAllowed permissions={['Create Purchase Order']}>
														<button
															type="button"
															onClick={() => savePurchaseOrder()}
															className="btn btn-primary btn-outlined-main"
															disabled={isInternalLoading || isSaveButtonDisabled}
														>
															{isSaveButtonDisabled ? (
																<>
																	<FaSpinner className="fa-spin" /> Saving...
																</>
															) : (
																<>
																	<FaSave /> Save
																</>
															)}
														</button>
													</PermissionAllowed>
												</>
											) : (
												<PermissionAllowed permissions={['Edit Purchase Order']}>
													<button
														type="button"
														onClick={() => updateSubmit()}
														className="btn btn-primary btn-outlined-main"
														disabled={isInternalLoading || isSaveButtonDisabled}
													>
														{isSaveButtonDisabled ? (
															<>
																<FaSpinner className="fa-spin" /> Updating...
															</>
														) : (
															<>
																<FaSave /> Update
															</>
														)}
													</button>
												</PermissionAllowed>
											)}
										</>
									)
								}
							</div>
						</div>
						<div className="row m-0">
							<div className={`${isMobile ? 'mobile-scroll-container w-100' : 'card shadow-sm rounded bg-white mb-4 p-3 p-xl-4 w-100'}`}>
								<div className="row">
									<div className="col-md-12 col-lg-12">
										<div className="row">
											<div className="col-12 col-md-6">
											

												<div className="row align-items-top form-group">
													<div
														className="col-12"
														style={{
															display: 'flex',
															alignItems: 'center',
															textAlign: isMobile ? 'left' : 'right',
															justifyContent: isMobile ? 'space-between' : ''
														}}
													>
														<div className="textGray" style={{ width: isMobile ? '' : '150px' }}>
															Supplier
														</div>
														<div style={{ width: isMobile ? '200px' : '300px', marginLeft: '10px' }}>
															{
																disableForm ? (
																	<>
																		<div className="w-full">
																			<Skeleton variant="rounded" width={'100%'} height={35} style={{ borderRadius: '32px' }} />
																		</div>
																	</>
																) : (
																	<>
																		{loaderStatus?.customers ? (
																			<Skeleton
																				style={{
																					minHeight: '32px',
																					height: '32px',
																					transformOrigin: '0 0',
																					transform: 'scale(1,1)',
																					width: '250px'
																				}}
																			></Skeleton>
																		) : (
																			<ReactSelect
																				className="rs-container"
																				classNamePrefix="rs"
																				name="customer"
																				options={supplierList}
																				value={supplierList?.find((c) => c?.value == purchaseOrder?.supplierId)}
																				onChange={(e) => {
																					handlePurchaseOrderInfo({
																						...purchaseOrder,
																						supplierId: e?.value
																					});
																				}}
																				menuPlacement="auto"
																				menuPosition="fixed"
																				placeholder="Select"
																				style={{ borderRadius: '18px' }}
																			/>
																		)}
																	</>
																)
															}
														</div>
													</div>
												</div>
												<div className="row align-items-top form-group">
													<div
														className="col-12"
														style={{
															display: 'flex',
															alignItems: 'center',
															textAlign: isMobile ? 'left' : 'right',
															justifyContent: isMobile ? 'space-between' : ''
														}}
													>
														<div className="textGray" style={{ width: isMobile ? '' : '150px' }}>
															Purchase Invoice #
														</div>
														<div style={{ width: isMobile ? '200px' : '300px', marginLeft: '10px', textAlign: 'left' }}>
															{
																disableForm ? (
																	<>
																		<div className="w-full">
																			<Skeleton variant="rounded" width={'100%'} height={35} style={{ borderRadius: '32px' }} />
																		</div>
																	</>
																) : (
																	<>
																		<div>
																			<input
																				type="text"
																				className="form-control"
																				id="inputName"
																				maxLength={50}
																				value={purchaseOrder?.purchaseInvoiceNumber}
																				onChange={(e) => {
																					handlePurchaseOrderInfo({
																						...purchaseOrder,
																						purchaseInvoiceNumber: e?.target?.value
																					});
																				}}
																			/>
																		</div>
																	</>
																)
															}
														</div>
													</div>
												</div>
												<div className="row align-items-top form-group">
													<div
														className="col-12"
														style={{
															display: 'flex',
															alignItems: 'center',
															textAlign: isMobile ? 'left' : 'right',
															justifyContent: isMobile ? 'space-between' : ''
														}}
													>
														<div className="textGray" style={{ width: isMobile ? '' : '150px' }}>
															Purchase Date
														</div>
														<div style={{ width: isMobile ? '200px' : '300px', marginLeft: '10px' }}>
															{
																disableForm ? (
																	<>
																		<div className="w-full">
																			<Skeleton variant="rounded" width={'100%'} height={35} style={{ borderRadius: '32px' }} />
																		</div>
																	</>
																) : (
																	<>
																		<input
																			type="date"
																			value={purchaseOrder?.expectedDate}
																			style={{ cursor: 'pointer' }}
																			className="form-control form-inp"
																			onClick={(e) => e.target.focus()}
																			onChange={(e) => {
																				// handleChangeCurrency(e?.target?.value);
																				handlePurchaseOrderInfo({
																					...purchaseOrder,
																					expectedDate: e?.target?.value
																				});
																			}}
																		/>
																	</>
																)
															}
														</div>
													</div>
												</div>
												<div className="row align-items-top form-group">
													<div
														className="col-12"
														style={{
															display: 'flex',
															alignItems: 'center',
															textAlign: isMobile ? 'left' : 'right',
															justifyContent: isMobile ? 'space-between' : ''
														}}
													>
														<div className="textGray" style={{ width: isMobile ? '' : '150px' }}>
															Warehouse
														</div>
														<div style={{ width: isMobile ? '200px' : '300px', marginLeft: '10px' }}>
															{
																disableForm ? (
																	<>
																		<div className="w-full">
																			<Skeleton variant="rounded" width={'100%'} height={35} style={{ borderRadius: '32px' }} />
																		</div>
																	</>
																) : (
																	<>
																		<ReactSelect
																			className="rs-container"
																			classNamePrefix="rs"
																			name="transit-company"
																			options={warehouseList}
																			value={warehouseList?.find((c) => c?.value == purchaseOrder?.warehouseId)}
																			onChange={(e) => {
																				handlePurchaseOrderInfo({
																					...purchaseOrder,
																					warehouseId: e?.value
																				});
																			}}
																			menuPlacement="auto"
																			menuPosition="fixed"
																			placeholder="Select"
																			style={{ borderRadius: '18px' }}
																		/>
																	</>
																)
															}
														</div>
													</div>
												</div>
												<div className="row align-items-top form-group">
													<div
														className="col-12"
														style={{
															display: 'flex',
															alignItems: 'center',
															textAlign: isMobile ? 'left' : 'right',
															justifyContent: isMobile ? 'space-between' : ''
														}}
													>
														<div className="textGray" style={{ width: isMobile ? '' : '150px' }}>
															Currency
														</div>
														<div style={{ width: '200px', marginLeft: '10px' }}>
															{
																disableForm ? (
																	<>
																		<div className="w-full">
																			<Skeleton variant="rounded" width={'100%'} height={35} style={{ borderRadius: '32px' }} />
																		</div>
																	</>
																) : (
																	<>
																		<Select
																			className="rs-container-est-white"
																			classNamePrefix="rs"
																			isSearchable={true}
																			name="customer"
																			options={currencies}
																			value={currencies?.find((c) => c?.value == purchaseOrder?.currency)}
																			onChange={(e) => {
																				handlePurchaseOrderInfo({
																					...purchaseOrder,
																					currency: e?.value
																				});
																			}}
																		/>
																	</>
																)
															}
														</div>
													</div>
												</div>
												<div className="row align-items-top form-group">
													<div
														className="col-12"
														style={{
															display: 'flex',
															alignItems: 'center',
															textAlign: isMobile ? 'left' : 'right',
															justifyContent: isMobile ? 'space-between' : ''
														}}
													>
														<div className="textGray" style={{ width: isMobile ? '' : '150px' }}>
															Payment Method
														</div>
														<div style={{ width: isMobile ? '200px' : '300px', marginLeft: '10px' }}>
															{
																disableForm ? (
																	<>
																		<div className="w-full">
																			<Skeleton variant="rounded" width={'100%'} height={35} style={{ borderRadius: '32px' }} />
																		</div>
																	</>
																) : (
																	<>
																		<Select
																			className="rs-container-est-white"
																			classNamePrefix="rs"
																			isSearchable={true}
																			name="customer"
																			options={paymentMethods}
																			value={paymentMethods?.find((c) => c?.value == purchaseOrder?.paymentMethod)}
																			onChange={(e) => {
																				handlePurchaseOrderInfo({
																					...purchaseOrder,
																					paymentMethod: e?.value
																				});
																			}}
																		/>
																	</>
																)
															}
														</div>
													</div>
												</div>
												<div className="row align-items-top form-group">
													<div
														className="col-12"
														style={{
															display: 'flex',
															alignItems: 'center',
															textAlign: isMobile ? 'left' : 'right',
															justifyContent: isMobile ? 'space-between' : ''
														}}
													>
														<div className="textGray" style={{ width: isMobile ? '' : '150px' }}>
															Notes
														</div>
														<div style={{ textAlign: 'left' }}>
															<div style={{ width: isMobile ? '200px' : '300px', marginLeft: '10px' }}>
															{
																disableForm ? (
																	<>
																		<div className="w-full">
																			<Skeleton variant="rounded" width={'100%'} height={35} style={{ borderRadius: '32px' }} />
																		</div>
																	</>
																) : (
																	<>
																		<MentionInput
																			onContentChange={(e, x, y) => {
																				// setNoteInputValue(JSON.stringify(e));
																				setNoteInputPlain(x);
																				setNoteMentions(y);
																				handlePurchaseOrderInfo({
																					...purchaseOrder,
																					notes: x
																				});
																			}}
																			clear={clearInput}
																			inputFocus={inputFocus}
																			setInputFocus={(e) => {
																				setInputFocus(e);
																			}}
																			triggerSave={() => {
																				// if(noteInputPlain.length > 0) {
																				//     // addNote && addNote(noteInputValue, selectedNoteType, noteMentions, noteInputPlain);
																				//     // clearInputField();
																				// }
																			}}
																			enableMention={false}
																		/>
																	</>
																)
															}

															</div>
														</div>
													</div>
												</div>


											</div>
											<div className="col-12 col-md-6">
											

												<div className="row mb-3">
													<div className="col-12 flex justify-center align-center ">
													{/* <div className="col-12"> */}
														{
															disableForm ? (
																<>
																	<div 
																		className="add-item-empty-div"
																		style={{
																			alignItems: 'center',
																			height: '320px',
																			width: '300px',
																			padding: 0,
																		}}
																	>
																		<Skeleton variant="rounded" width={'100%'} height={'320px'} style={{ borderRadius: '8px' }} />
																	</div>
																</>
															) : (
																<>
																	{
																		purchaseOrder?.attachmentId ? (
																			<>
																				<div
																					className="uploaded-attachment-preview"
																					onMouseEnter={() => setShowAttachmentActions(true)}
																					onMouseLeave={() => setShowAttachmentActions(false)}
																					style={{ position: 'relative' }}
																				>

																					{/* <div className="card-body text-center" style={{ padding: '0px', height: '320px', width: '300px', }}> */}
																					<div className="card-body text-center" style={{ padding: '0px' }}>
																						{purchaseOrder?.attachmentExtension === 'pdf' ? (
																							  <iframe
																								src={`${purchaseOrder?.attachmentUrl}#toolbar=0&navpanes=0&zoom=FitW`}
																								style={{
																									width: '400px',
																									// minHeight: '320px',
																									// height: isMobile ? '320px' : '600px',
																									height: '320px',
																									border: 'none',
																									borderRadius: 8,
																									background: '#fff',
																									display: 'block'
																								}}
																								title="PDF Preview"
																								/>
																							// <PdfViewer src={attachmentPreviewDetails?.url + '#toolbar=0&navpanes=0&zoom=FitW'} style={{ height: '320px'}} />
																						) : (
																							<img src={purchaseOrder?.attachmentUrl} className="img-fluid" />
																						)}
																						{showAttachmentActions && (
																							<div
																								style={{
																									position: 'absolute',
																									display: 'flex',
																									justifyContent: 'center',
																									alignItems: 'center',
																									height: '100%',
																									gap: '10px',
																									top: 0,
																									left: 0,
																									width: '100%',
																									background: 'rgba(255,255,255,0.7)',
																									zIndex: 2,
																								}}
																							>
																								<a
																									href={`${purchaseOrder?.attachmentUrl}`}
																									target="_blank"
																									className="btn btn-primary btn-outlined-main"
																								>
																									Download
																								</a>
																								<button
																									type="button"
																									className="btn btn-danger flex items-center"
																									onClick={() => removeAttachment(purchaseOrder?.attachmentId)}
																								>
																									Delete
																								</button>
																							</div>
																						)}
																					</div>
																				</div>
																			</>
																		) : (
																			<>
																				<div
																					{...getAttachmentRootProps()}
																					className="flex justify-center align-center flex-column uploadBox"
																					style={{
																						// background: isDragActive || dropzoneDragActive ? '#e3f2fd' : '',
																						alignItems: 'center',
																						// border: isDragActive || dropzoneDragActive ? '2px dashed #1976d2' : '',
																					}}
																				>
																					<div
																						className="add-item-empty-div"
																						style={{
																							alignItems: 'center',
																							height: '320px',
																							width: '400px',
																							// transition: 'background 0.3s, border 0.3s',
																							backgroundColor: isDragActive || dropzoneDragActive ? '#e3f2fd' : '',
																							border: isDragActive || dropzoneDragActive ? '2px dashed #1976d2' : '',
																							opacity: isDragActive || dropzoneDragActive ? 0.8 : 1,
																						}}
																					>
																						{/* <div> */}
																							{isDragActive || dropzoneDragActive ? (
																								<div style={{ textAlign: 'center', color: '#1976d2', fontWeight: 600, fontSize: 18 }}>
																									<FaPlus style={{ fontSize: 32, marginBottom: 8 }} />
																									<div>Drop file here</div>
																								</div>
																							) : (
																								<>
																									<div
																										className="text-primary"
																										style={{
																											marginTop: '1px',
																											padding: '5px 7px',
																											border: '2px solid #9e9e9e',
																											borderRadius: '32px',
																										}}
																									>
																										<PlusIcon height="16px" width="16px" />
																									</div>
																									<div style={{ marginLeft: '10px' }}>
																										<div
																											className='flex'
																											style={{
																												gap: '5px'
																											}}
																										>
																											<span className="fw-500">Drag & Drop or Click to Upload</span>
																											<span className="text-gray-700">OR</span>
																											<span className="text-blue-600 fw-500">Browse Files</span>
																										</div>
																										<div className="text-gray-600 fw-400 mt-1 flex align-items-center" style={{ fontSize: '10px', gap: '5px' }}>
																											<InfoIcon width='14px' height='14px' />
																											<span>
																												png, jpg, jpeg or pdf (Max file size: 5MB)
																											</span>
																										</div>
																									</div>
																									{/* <button type="button" className="btn btn-primary btn-outlined-main-primary dragText">
																										<FaPlus />
																										Add File
																									</button>
																									<div className="text-center text-gray-600" style={{ marginTop: '5px' }}>or drag file...</div> */}
																								</>
																							)}
																						{/* </div> */}
																					</div>
																					<input {...getAttachmentInputProps({ disabled: false })} style={{ display: 'none' }} />{' '}
																				</div>
																			</>
																		)
																	}
																</>
															)
														}
													</div>
												</div>

											</div>
										</div>

										{!isMobile ? (
											<div className="productsTable estlist" style={{ fontSize: '12px' }}>
												<div className="table-responsive-xl tableData">
													<div className="">
														<div className="row">
															<div className="col-6">
																<h2 className="font500 font18 font500">Products</h2>
															</div>
															{hasProducts && (
																<div className="col-6 text-right" style={{ display: 'flex', justifyContent: 'right', marginTop: '-10px' }}>
																	<button type="button" className="btn btn-primary btn-outlined-main" onClick={handleSelectRow}>
																		<FaPlus />
																		Add Products
																	</button>
																</div>
															)}
														</div>
													</div>
													{!hasProducts ? (
														<>
															<div className="row">
																<div className="col-12">
																	<div className="add-product-empty-div">
																		<button
																			type="button"
																			className={`btn btn-primary btn-outlined-main-primary ${isProductsLoading ? 'disabled' : ''}`}
																			onClick={() => {
																				if (!isProductsLoading) {
																					handleSelectRow();
																				}
																			}}
																			disabled={isProductsLoading}
																		>
																			{
																				(isProductsLoading) ? (
																					<>
																						<FaSpinner className="fa-spin" /> Retrieving Products...
																					</>
																				) : (
																					<>
																						<FaPlus />
																						Add Products
																					</>
																				)
																			}
																		</button>
																	</div>
																</div>
															</div>
														</>
													) : (
														<>
															{
																newFormVersion ? (
																	<>
																		<table className="table table-md text-gray-900 formActBtns border-0" style={{ marginTop: '10px' }}>
																			<thead>
																				<tr>
																					<th className="align-middle" style={{ width: '5%' }}></th>
																					<th className="align-middle" style={{ width: '45%' }}>
																						Name
																					</th>
																					{/* <th className="align-middle" style={{ width: '12%' }}>
																						Free Stock
																					</th> */}
																					<th className="align-middle" style={{ width: '12%' }}>
																						Ordered
																					</th>
																					<th className="align-middle" style={{ width: '12%' }}>
																						Price
																					</th>
																					<th className="align-middle" style={{ width: '12%' }}>
																						Total
																					</th>
																					<th className="align-middle text-center" style={{ width: '2%' }}></th>
																				</tr>
																			</thead>
																			<tbody>
																				{selectedRowsData?.length > 0 ? (
																					selectedRowsData?.map((row, index) => (
																						<>
																							<tr key={row?.product_id}>
																								<td className="align-middle estimateCName text-center">
																									{row?.thumbnailUrl ? (
																										<img src={row?.thumbnailUrl} style={{ width: '30px', height: '50px' }} alt="product" />
																									) : (
																										<img src={NoImage} style={{ width: '30px' }} alt="product" />
																									)}
																								</td>
																								<td className="align-middle estimateCName">
																									<div className="">
																										{row?.product_name || row.product}
																										{row?.selectedColorName ? ` ${row.selectedColorName}` : ''}
																									</div>
																									<div className="textGray">{row?.sku}</div>
																								</td>
																								{/* <td className="align-middle estimateCName">
																									{row?.free_stock}{' '}
																									{parseInt(row?.purchased_quantity) > 0 && (
																										<>
																											<Tooltip
																												title={<span style={{ fontSize: '13px' }}>Already purchased</span>}
																												arrow
																												placement="top"
																											>
																												<span className="textGray">
																													+ <span>{row?.purchased_quantity}</span>
																												</span>
																											</Tooltip>
																										</>
																									)}
																								</td> */}
																								<td className="align-middle ">
																									<input
																										className="numField"
																										type="number"
																										value={row?.quantity}
																										maxLength={10}
																										onChange={(e) => {
																											if (row.product_id) {
																												const newVal = e.target.value;
																												if (newVal.length <= 10) {
																													handleQuantityChange(index, newVal);
																													// handleQuantityChange(row.product_id, newVal);
																												}
																											}
																										}}
																										style={{ paddingInline: '3px' }}
																										onFocus={(event) => {
																											if (event.target.value === '0') {
																												event.target.value = '';
																											}
																										}}
																									/>
																								</td>
																								<td className="align-middle">
																									<div className="input-group" style={{ display: 'flex' }}>
																										<div className="input-group-prepend">
																											<span className="input-group-text" id="basic-addon1">
																												{purchaseOrder?.currency === 'usd'
																													? '$'
																													: purchaseOrder?.currency === 'eur'
																													? '€'
																													: purchaseOrder?.currency === 'aed'
																													? 'AED'
																													: purchaseOrder?.currency}
																											</span>
																										</div>

																										<input
																											className="numField form-control"
																											type="number"
																											value={row?.converted_currency_price[purchaseOrder?.currency]}
																											placeholder="0"
																											maxLength={10}
																											onChange={(e) => {
																												if (row.product_id) {
																													const newVal = e.target.value;
        																											handleUnitPriceChange(index, e.target.value);
																													// handleUnitPriceChange(row.product_id, newVal);
																												}
																											}}
																											style={{ paddingInline: '3px', maxWidth: '120px' }}
																											onFocus={(event) => {
																												// If value is less than 1, clear the field on focus
																												if (parseFloat(event.target.value) < 1) {
																													event.target.value = '';
																												}
																											}}
																										/>
																									</div>

																								</td>
																								<td className="align-middle">
																									{purchaseOrder?.currency === 'usd' ? '$ ' : purchaseOrder?.currency === 'aed' ? 'AED ' : '€ '}{' '}
																									{parseFloat(row.converted_currency_total[purchaseOrder?.currency])
																										.toFixed(2)
																										.replace(/\d(?=(\d{3})+\.)/g, '$&,') || '0.00'}
																								</td>
																								<td className="align-middle text-center">
																									{row.product_id ? (
																										<span
																											style={{ cursor: 'pointer' }}
																											onClick={() => {
																												removeRow(row?.id, row.product_id);
																											}}
																										>
																											<svg
																												id="vuesax_linear_trush-square"
																												data-name="vuesax/linear/trush-square"
																												xmlns="http://www.w3.org/2000/svg"
																												width="20"
																												height="20"
																												viewBox="0 0 31.855 31.855"
																											>
																												<g id="trush-square">
																													<path
																														id="Vector"
																														d="M0,17.255V9.291C0,2.655,2.655,0,9.291,0h7.964c6.637,0,9.291,2.655,9.291,9.291v7.964c0,6.637-2.655,9.291-9.291,9.291H9.291C2.655,26.546,0,23.891,0,17.255Z"
																														transform="translate(2.655 2.655)"
																														fill="none"
																														stroke="#ff342d"
																														strokeLinecap="round"
																														strokeLinejoin="round"
																														strokeWidth="2"
																													/>
																													<g id="Group" transform="translate(8.097 8.548)">
																														<path
																															id="Vector-2"
																															data-name="Vector"
																															d="M0,.438,1.779.265A51.533,51.533,0,0,1,6.942,0a86.992,86.992,0,0,1,8.72.438"
																															transform="translate(0 3.026)"
																															fill="none"
																															stroke="#ff342d"
																															strokeLinecap="round"
																															strokeLinejoin="round"
																															strokeWidth="2"
																														/>
																														<path
																															id="Vector-3"
																															data-name="Vector"
																															d="M0,2.588.186,1.447C.319.624.425,0,1.9,0H4.181C5.654,0,5.76.65,5.893,1.447l.186,1.128"
																															transform="translate(4.792)"
																															fill="none"
																															stroke="#ff342d"
																															strokeLinecap="round"
																															strokeLinejoin="round"
																															strokeWidth="2"
																														/>
																														<path
																															id="Vector-4"
																															data-name="Vector"
																															d="M11.932,0l-.571,8.76c-.093,1.367-.173,2.429-2.6,2.429H3.172c-2.429,0-2.509-1.062-2.6-2.429L0,0"
																															transform="translate(1.858 3.57)"
																															fill="none"
																															stroke="#ff342d"
																															strokeLinecap="round"
																															strokeLinejoin="round"
																															strokeWidth="2"
																														/>
																													</g>
																													<path
																														id="Vector-5"
																														data-name="Vector"
																														d="M0,0H31.855V31.855H0Z"
																														fill="none"
																														opacity="0"
																													/>
																												</g>
																											</svg>
																										</span>
																									) : (
																										''
																									)}
																								</td>
																							</tr>
																						</>
																					))
																				) : (
																					<tr className="no-hover">
																						<td colSpan={9}>
																							<div className="not-found-container cstm-not-found">
																								<div className="not-found-icon">
																									<TbDatabaseExclamation />
																								</div>
																								<h6 className="not-found-text">No Products Selected</h6>
																								<button type="button" className="btn btn-primary btn-outlined-main" onClick={handleSelectRow}>
																									<FaPlus />
																									Add Products
																								</button>
																							</div>
																						</td>
																					</tr>
																				)}
																			</tbody>
																			{selectedRowsData?.length > 0 ? (
																				<tfoot>
																					<tr className="tr-nth">
																						<td className="align-middle estimateCName" colSpan={`${newFormVersion ? '2' : '3' }`}></td>
																						<td className="text-left">
																							<label>{Number(totalQuantity).toLocaleString()}  { Number(totalQuantity) < 2 ? 'pc' : 'pcs' }</label>
																						</td>
																						<td className="align-middle">Subtotal</td>
																						<td className="align-middle" colSpan="2">
																							<label>
																								{purchaseOrder?.currency === 'usd' ? ' $ ' : purchaseOrder?.currency === 'aed' ? ' AED ' : ' € '}{' '}
																								{/* {totalPrice ? totalPrice?.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,') : 0} */}
																								{Number(convertedTotalPrice[purchaseOrder?.currency] || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
																							</label>
																						</td>
																					</tr>
																					<tr className="">
																						<td className="align-middle estimateCName" colSpan={`${newFormVersion ? '3' : '4' }`}></td>
																						<td className="align-middle">Shipping</td>
																						<td className="align-middle" colSpan="2">
																							<div className="input-group" style={{ display: 'flex' }}>
																								<div className="input-group-prepend">
																									<span className="input-group-text" id="basic-addon1">
																										{purchaseOrder?.currency === 'usd'
																											? '$'
																											: purchaseOrder?.currency === 'eur'
																											? '€'
																											: purchaseOrder?.currency === 'aed'
																											? 'AED'
																											: purchaseOrder?.currency}
																									</span>
																								</div>

																								<input
																									className="form-control"
																									type="number"
																									value={`${purchaseOrder?.shippingFee}`}
																									placeholder="0"
																									maxLength={10}
																									style={{ maxWidth: '120px' }}
																									// onChange={e => handleQuantityChange(index, e.target.value)}
																									// onChange={e => handlePurchasePriceChange(e, item, index)}

																									onChange={(e) => {
																										const value = e?.target?.value ? e?.target?.value : 0;
																										setPurchaseOrder({
																											...purchaseOrder,
																											shippingFee: value
																										});
																									}}
																										// onChange={(e) => {
																										// 	if (row.product_id) {
																										// 		const newVal = e.target.value;
																										// 		if (newVal.length <= 10) {
																										// 			handleQuantityChange(index, newVal);
																										// 			// handleQuantityChange(row.product_id, newVal);
																										// 		}
																										// 	}
																										// }}

																									onFocus={(event) => {
																										if (event.target.value === '0' || event.target.value === '0.00') {
																											event.target.value = '';
																										}
																									}}
																								/>
																							</div>
																						</td>
																					</tr>
																					<tr className="">
																						<td className="align-middle estimateCName" colSpan={`${newFormVersion ? '3' : '4' }`}></td>
																						<td className="align-middle">Total</td>
																						<td className="align-middle" colSpan="2">
																							<label>
																								{purchaseOrder?.currency === 'usd' ? ' $ ' : purchaseOrder?.currency === 'aed' ? ' AED ' : ' € '}{' '}
																								{/* {totalPrice ? totalPrice?.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,') : 0} */}
																								{(
																									parseFloat(convertedTotalPrice[purchaseOrder?.currency]) +
																									parseFloat(purchaseOrder?.shippingFee ?? 0)
																								)
																									.toFixed(2)
																									.replace(/\d(?=(\d{3})+\.)/g, '$&,')}
																							</label>
																						</td>
																					</tr>
																				</tfoot>
																			) : (
																				<></>
																			)}
																		</table>
																	</>
																) : (
																	<>
																		<table className="table table-md text-gray-900 formActBtns border-0" style={{ marginTop: '10px' }}>
																			<thead>
																				<tr>
																					<th className="align-middle" style={{ width: '5%' }}></th>
																					<th className="align-middle" style={{ width: '45%' }}>
																						Name
																					</th>
																					<th className="align-middle" style={{ width: '12%' }}>
																						Free Stock
																					</th>
																					<th className="align-middle" style={{ width: '12%' }}>
																						Ordered
																					</th>
																					<th className="align-middle" style={{ width: '12%' }}>
																						Price
																					</th>
																					<th className="align-middle" style={{ width: '12%' }}>
																						Total
																					</th>
																					<th className="align-middle text-center" style={{ width: '2%' }}></th>
																				</tr>
																			</thead>
																			<tbody>
																				{selectedRowsData?.length > 0 ? (
																					selectedRowsData?.map((row, index) => (
																						<>
																							<tr key={row?.product_id}>
																								<td className="align-middle estimateCName text-center">
																									{/* {row?.thumbnail_url ? (
																										<img src={row?.thumbnail_url} style={{ width: '30px', height: '50px' }} alt="product" />
																									) : row?.custom_thumbnail_url ? (
																										<img
																											src={row?.custom_thumbnail_url}
																											style={{ width: '30px', height: '50px' }}
																											alt="product"
																										/>
																									) : (
																										<img src={NoImage} style={{ width: '30px' }} alt="product" />
																									)} */}

																									{row?.thumbnailUrl ? (
																										<img src={row?.thumbnailUrl} style={{ width: '30px', height: '50px' }} alt="product" />
																									) : (
																										<img src={NoImage} style={{ width: '30px' }} alt="product" />
																									)}
																								</td>
																								<td className="align-middle estimateCName">
																									<div className="">{row?.product_name || row.product}</div>
																									<div className="textGray">{row?.sku}</div>
																								</td>
																								<td className="align-middle estimateCName">
																									{row?.free_stock}{' '}
																									{parseInt(row?.purchased_quantity) > 0 && (
																										<>
																											<Tooltip
																												title={<span style={{ fontSize: '13px' }}>Already purchased</span>}
																												arrow
																												placement="top"
																											>
																												<span className="textGray">
																													+ <span>{row?.purchased_quantity}</span>
																												</span>
																											</Tooltip>
																										</>
																									)}
																								</td>
																								<td className="align-middle ">
																									<input
																										className="numField"
																										type="number"
																										value={row?.quantity}
																										maxLength={10}
																										onChange={(e) => {
																											if (row.product_id) {
																												const newVal = e.target.value;
																												if (newVal.length <= 10) {
																													handleQuantityChange(row.product_id, newVal);
																												}
																											}
																										}}
																										style={{ paddingInline: '3px' }}
																										onFocus={(event) => {
																											// event.target.select();
																											if (event.target.value === '0') {
																												event.target.value = '';
																											}
																										}}
																									/>
																								</td>
																								<td className="align-middle">
																									<div className="input-group" style={{ display: 'flex' }}>
																										<div className="input-group-prepend">
																											<span className="input-group-text" id="basic-addon1">
																												{purchaseOrder?.currency === 'usd'
																													? '$'
																													: purchaseOrder?.currency === 'eur'
																													? '€'
																													: purchaseOrder?.currency === 'aed'
																													? 'AED'
																													: purchaseOrder?.currency}
																											</span>
																										</div>

																										<input
																											className="numField form-control"
																											type="number"
																											value={row?.converted_currency_price[purchaseOrder?.currency]}
																											placeholder="0"
																											maxLength={10}
																											// onChange={e => handleQuantityChange(index, e.target.value)}
																											// onChange={e => handlePurchasePriceChange(e, item, index)}

																											onChange={(e) => {
																												if (row.product_id) {
																													const newVal = e.target.value;
																													// if (newVal.length <= 6) {
																													handleUnitPriceChange(row.product_id, newVal);
																													// }
																												}
																											}}
																											style={{ paddingInline: '3px' }}
																											onFocus={(event) => {
																												// event.target.select();
																												if (event.target.value === '0') {
																													event.target.value = '';
																												}
																											}}
																										/>
																									</div>

																									{/* <input
																									className="numField"
																									type="number"
																									value={row?.price}
																									onChange={(e) => {
																										if (row.product_id) {
																											const newVal = e.target.value;
																											if (newVal.length <= 6) {
																												handleUnitPriceChange(row.product_id, newVal);
																											}
																										}
																									}}
																									style={{ width: '60px', paddingInline: '3px' }}
																									onFocus={(event) => {
																										// event.target.select();

																										if (event.target.value == '0.00' || event.target.value == '0') {
																											// handleUnitPriceChange(index, '');
																										}
																										event.target.select();
																									}}
																								/> */}
																								</td>
																								<td className="align-middle">
																									{purchaseOrder?.currency === 'usd' ? '$ ' : purchaseOrder?.currency === 'aed' ? 'AED ' : '€ '}{' '}
																									{parseFloat(row.converted_currency_total[purchaseOrder?.currency])
																										.toFixed(2)
																										.replace(/\d(?=(\d{3})+\.)/g, '$&,') || '0.00'}
																								</td>
																								<td className="align-middle text-center">
																									{row.product_id ? (
																										<span
																											style={{ cursor: 'pointer' }}
																											onClick={() => {
																												removeRow(row?.id, row.product_id);
																											}}
																										>
																											<svg
																												id="vuesax_linear_trush-square"
																												data-name="vuesax/linear/trush-square"
																												xmlns="http://www.w3.org/2000/svg"
																												width="20"
																												height="20"
																												viewBox="0 0 31.855 31.855"
																											>
																												<g id="trush-square">
																													<path
																														id="Vector"
																														d="M0,17.255V9.291C0,2.655,2.655,0,9.291,0h7.964c6.637,0,9.291,2.655,9.291,9.291v7.964c0,6.637-2.655,9.291-9.291,9.291H9.291C2.655,26.546,0,23.891,0,17.255Z"
																														transform="translate(2.655 2.655)"
																														fill="none"
																														stroke="#ff342d"
																														strokeLinecap="round"
																														strokeLinejoin="round"
																														strokeWidth="2"
																													/>
																													<g id="Group" transform="translate(8.097 8.548)">
																														<path
																															id="Vector-2"
																															data-name="Vector"
																															d="M0,.438,1.779.265A51.533,51.533,0,0,1,6.942,0a86.992,86.992,0,0,1,8.72.438"
																															transform="translate(0 3.026)"
																															fill="none"
																															stroke="#ff342d"
																															strokeLinecap="round"
																															strokeLinejoin="round"
																															strokeWidth="2"
																														/>
																														<path
																															id="Vector-3"
																															data-name="Vector"
																															d="M0,2.588.186,1.447C.319.624.425,0,1.9,0H4.181C5.654,0,5.76.65,5.893,1.447l.186,1.128"
																															transform="translate(4.792)"
																															fill="none"
																															stroke="#ff342d"
																															strokeLinecap="round"
																															strokeLinejoin="round"
																															strokeWidth="2"
																														/>
																														<path
																															id="Vector-4"
																															data-name="Vector"
																															d="M11.932,0l-.571,8.76c-.093,1.367-.173,2.429-2.6,2.429H3.172c-2.429,0-2.509-1.062-2.6-2.429L0,0"
																															transform="translate(1.858 3.57)"
																															fill="none"
																															stroke="#ff342d"
																															strokeLinecap="round"
																															strokeLinejoin="round"
																															strokeWidth="2"
																														/>
																													</g>
																													<path
																														id="Vector-5"
																														data-name="Vector"
																														d="M0,0H31.855V31.855H0Z"
																														fill="none"
																														opacity="0"
																													/>
																												</g>
																											</svg>
																										</span>
																									) : (
																										''
																									)}
																								</td>
																							</tr>
																						</>
																					))
																				) : (
																					<tr className="no-hover">
																						<td colSpan={9}>
																							<div className="not-found-container cstm-not-found">
																								<div className="not-found-icon">
																									<TbDatabaseExclamation />
																								</div>
																								<h6 className="not-found-text">No Products Selected</h6>
																								<button type="button" className="btn btn-primary btn-outlined-main" onClick={handleSelectRow}>
																									<FaPlus />
																									Add Products
																								</button>
																							</div>
																						</td>
																					</tr>
																				)}
																			</tbody>
																			{selectedRowsData?.length > 0 ? (
																				<tfoot>
																					<tr className="tr-nth">
																						<td className="align-middle estimateCName" colSpan={3}></td>
																						<td className="text-center">
																							<label>{totalQuantity} pcs</label>
																						</td>
																						<td className="align-middle">Subtotal</td>
																						<td className="align-middle">
																							<label>
																								{purchaseOrder?.currency === 'usd' ? ' $ ' : purchaseOrder?.currency === 'aed' ? ' AED ' : ' € '}{' '}
																								{/* {totalPrice ? totalPrice?.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,') : 0} */}
																								{parseFloat(convertedTotalPrice[purchaseOrder?.currency])
																									.toFixed(2)
																									.replace(/\d(?=(\d{3})+\.)/g, '$&,')}
																							</label>
																						</td>
																						<td className="align-middle text-center"></td>
																					</tr>
																					<tr className="">
																						<td className="align-middle estimateCName" colSpan={4}></td>
																						<td className="align-middle">Shipping</td>
																						<td className="align-middle">
																							<div className="input-group" style={{ display: 'flex' }}>
																								<div className="input-group-prepend">
																									<span className="input-group-text" id="basic-addon1">
																										{purchaseOrder?.currency === 'usd'
																											? '$'
																											: purchaseOrder?.currency === 'eur'
																											? '€'
																											: purchaseOrder?.currency === 'aed'
																											? 'AED'
																											: purchaseOrder?.currency}
																									</span>
																								</div>

																								<input
																									className="form-control"
																									type="number"
																									value={`${purchaseOrder?.shippingFee}`}
																									placeholder="0"
																									maxLength={10}
																									// onChange={e => handleQuantityChange(index, e.target.value)}
																									// onChange={e => handlePurchasePriceChange(e, item, index)}

																									onChange={(e) => {
																										const value = e?.target?.value ? e?.target?.value : 0;
																										setPurchaseOrder({
																											...purchaseOrder,
																											shippingFee: value
																										});
																									}}
																								/>
																							</div>
																						</td>
																						<td className="align-middle text-center"></td>
																					</tr>
																					<tr className="">
																						<td className="align-middle estimateCName" colSpan={4}></td>
																						<td className="align-middle">Total</td>
																						<td className="align-middle">
																							<label>
																								{purchaseOrder?.currency === 'usd' ? ' $ ' : purchaseOrder?.currency === 'aed' ? ' AED ' : ' € '}{' '}
																								{/* {totalPrice ? totalPrice?.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,') : 0} */}
																								{(
																									parseFloat(convertedTotalPrice[purchaseOrder?.currency]) +
																									parseFloat(purchaseOrder?.shippingFee ?? 0)
																								)
																									.toFixed(2)
																									.replace(/\d(?=(\d{3})+\.)/g, '$&,')}
																							</label>
																						</td>
																						<td className="align-middle text-center"></td>
																					</tr>
																				</tfoot>
																			) : (
																				<></>
																			)}
																		</table>
																	</>
																)
															}
														</>
													)}
												</div>
											</div>
										) : (
											<div className=" p-3 p-xl-4 w-100 new-card">
												<div style={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
													{!hasProducts ? (
														<>
															<div className="row">
																<div className="col-12">
																	<div className="add-product-empty-div">
																		<button type="button" className="btn btn-primary btn-outlined-main-primary" onClick={handleSelectRow}>
																			<FaPlus />
																			Add Products
																		</button>
																	</div>
																</div>
															</div>
														</>
													) : (
														<div
															style={{
																display: 'flex',
																justifyContent: 'space-between',
																width: '100%',
																alignItems: 'center',
																paddingBottom: '10px',
																borderBottom: '1px solid #eee'
															}}
														>
															<h2 className="font500 font18 font500 m-0">Products</h2>
															<button type="button" className="btn btn-primary btn-outlined-main-primary" onClick={handleSelectRow}>
																<FaPlus />
																Add Products
															</button>
														</div>
													)}
													{selectedRowsData?.length > 0 ? (
														selectedRowsData?.map((row, index) => (
															<div
																style={{
																	display: 'flex',
																	width: '100%',
																	flexDirection: 'column',
																	padding: '10px 0px',
																	borderBottom: '1px solid #eee'
																}}
															>
																<div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
																	<div style={{ display: 'flex', flexDirection: 'column' }}>
																		<div className="" style={{ display: 'flex' }}>
																			{row?.product_name || row.product}
																		</div>
																		<div className="textGray">SKU: {row?.sku}</div>
																		<div className="textGray">
																			Free Stock: {row?.free_stock} +{' '}
																			{parseInt(row?.purchased_quantity) > 0 && (
																				<>
																					<Tooltip
																						title={<span style={{ fontSize: '13px' }}>Already purchased</span>}
																						arrow
																						placement="top"
																					>
																						<span className="textGray">
																							+ <span>{row?.purchased_quantity}</span>
																						</span>
																					</Tooltip>
																				</>
																			)}
																		</div>
																	</div>
																	<div>
																		{row?.thumbnail_url ? (
																			<img
																				src={row?.thumbnail_url}
																				style={{ width: '100%', objectFit: 'cover', height: '70px' }}
																				alt="product"
																			/>
																		) : row?.custom_thumbnail_url ? (
																			<img
																				src={row?.custom_thumbnail_url}
																				style={{ width: '100%', objectFit: 'cover', height: '70px' }}
																				alt="product"
																			/>
																		) : (
																			<img src={NoImage} style={{ width: '100%', objectFit: 'cover', height: '70px' }} alt="product" />
																		)}
																	</div>
																</div>
																<div style={{ display: 'flex', justifyContent: 'center', alignItems: 'end', gap: 10 }}>
																	<div style={{ display: 'flex', flexDirection: 'column' }}>
																		<label>Quantity</label>
																		<input
																			className="numField"
																			type="number"
																			value={row?.quantity}
																			maxLength={10}
																			onChange={(e) => {
																				if (row.product_id) {
																					const newVal = e.target.value;
																					if (newVal.length <= 10) {
																						handleQuantityChange(row.product_id, newVal);
																					}
																				}
																			}}
																			style={{ paddingInline: '3px' }}
																			onFocus={(event) => {
																				// event.target.select();
																				if (event.target.value === '0') {
																					event.target.value = '';
																				}
																			}}
																		/>
																	</div>
																	<div style={{ display: 'flex', flexDirection: 'column' }}>
																		<label>Price</label>
																		<div className="input-group" style={{ display: 'flex' }}>
																			<div className="input-group-prepend">
																				<span className="input-group-text" id="basic-addon1">
																					{purchaseOrder?.currency === 'usd'
																						? '$'
																						: purchaseOrder?.currency === 'eur'
																						? '€'
																						: purchaseOrder?.currency === 'aed'
																						? 'AED'
																						: purchaseOrder?.currency}
																				</span>
																			</div>

																			<input
																				className="numField form-control"
																				type="number"
																				value={row?.converted_currency_price[purchaseOrder?.currency]}
																				placeholder="0"
																				maxLength={10}
																				// onChange={e => handleQuantityChange(index, e.target.value)}
																				// onChange={e => handlePurchasePriceChange(e, item, index)}

																				onChange={(e) => {
																					if (row.product_id) {
																						const newVal = e.target.value;
																						// if (newVal.length <= 6) {
																						handleUnitPriceChange(row.product_id, newVal);
																						// }
																					}
																				}}
																				style={{ paddingInline: '3px' }}
																				onFocus={(event) => {
																					// event.target.select();
																					if (event.target.value === '0') {
																						event.target.value = '';
																					}
																				}}
																			/>
																		</div>
																	</div>
																	<div style={{display: 'flex', alignItems: 'end', height: '100%', marginBottom: 2}}>
																		{row.product_id ? (
																			<div
																				className="btn btn-danger btn-outlined-danger white-var btn-sm cursor-pointer"
																				style={{ cursor: 'pointer', minWidth: 'unset' }}
																				onClick={() => {
																					removeRow(row?.id, row.product_id);
																				}}
																			>
																				<FiTrash2 size={20} />
																			</div>
																		) : (
																			''
																		)}
																	</div>
																</div>
															</div>
														))
													) : (
														<div>No products selected</div>
													)}
												</div>
											</div>
										)}
									</div>
								</div>
								<div className="">
									{alertMessage?.success && <span className="px-3 down-error text-success">{alertMessage?.success}</span>}
									{alertMessage?.failed && <span className="px-3 down-error text-danger">{alertMessage?.failed}</span>}
								</div>
							</div>
						</div>
						<div className="section-head hide-on-mobile" style={{ marginTop: '-17px' }}>
							<h2 style={{ display: 'flex', alignItems: 'center', gap: '5px', fontSize: '18px', marginLeft: '-10px' }}></h2>
							<div className="actions">
								{
									disableForm ? (
										<>
											<div style={{ width: '100px' }}>
												<Skeleton variant="rounded" width={'100%'} height={30} style={{ borderRadius: '8px' }} />
											</div>
										</>
									) : (
										<>
											{!edit ? (
												<>
													<PermissionAllowed permissions={['Create Purchase Order']}>
														<button
															type="button"
															onClick={() => savePurchaseOrder()}
															className="btn btn-primary btn-outlined-main"
															disabled={isInternalLoading || isSaveButtonDisabled}
														>
															{isSaveButtonDisabled ? (
																<>
																	<FaSpinner className="fa-spin" /> Saving...
																</>
															) : (
																<>
																	<FaSave /> Save
																</>
															)}
														</button>
													</PermissionAllowed>
												</>
											) : (
												<PermissionAllowed permissions={['Edit Purchase Order']}>
													<button
														type="button"
														onClick={() => updateSubmit()}
														className="btn btn-primary btn-outlined-main"
														disabled={isInternalLoading || isSaveButtonDisabled}
													>
														{isSaveButtonDisabled ? (
															<>
																<FaSpinner className="fa-spin" /> Updating...
															</>
														) : (
															<>
																<FaSave /> Update
															</>
														)}
													</button>
												</PermissionAllowed>
											)}
										</>
									)
								}
							</div>
						</div>
					</div>
				</div>
				{/* {openPopup && !isMobile && (
					<Modal show={openPopup} onHide={closeFound} centered size="lg">
						<div>
							<SelectionProvider>
								<ProductList
									selectedItems={selectedRowsData}
									close={handleDoneClick}
									currency={purchaseOrder?.currency}
									handleClose={closePopup}
								/>
							</SelectionProvider>
						</div>
					</Modal>
				)} */}
			
				{openPopup && !isMobile && (
					<div className="purchase-order-product-popup-modal">
						<Modal show={openPopup} onHide={closeFound} centered size="lg">
							<PurchaseOrderProductsModal
								onClose={() => {
									setOpenPopup(false);
								}}
								onSubmit={handleProductSubmit}
								currency={purchaseOrder?.currency}
								// orderType={orderType}
								// setOrderType={setOrderType}
								// customer={salesOrderData?.customer}
								// transitCompany={salesOrderData?.transitCompany}
								preLoadedData={{
									items: selectedRowsData,
									// invItems: productsData,
									// shippingFee,
									// discount,
									// selections: preloadedSelectionsProdModals
								}}
								products={products}
								grades={gradesLists}
								// onSubmit={handleProductSubmit}
								// currency={salesOrderData?.currency}
								// orderType={orderType}
								// setOrderType={setOrderType}
								// customer={salesOrderData?.customer}
								// transitCompany={salesOrderData?.transitCompany}
								// preLoadedData={{
								// 	invItems: productsData,
								// 	shippingFee,
								// 	discount,
								// 	selections: preloadedSelectionsProdModals
								// }}
								// products={products}
							/>
						</Modal>
					</div>
				)}
				{openPopup && isMobile && (
					<div
						className="d-flex"
						style={{
							width: '100vw',
							height: '100dvh',
							position: 'fixed',
							left: 0,
							top: 0,
							zIndex: 20,
							background: 'rgba(0,0,0,0.07)',
							justifyContent: 'center',
							alignItems: 'end',
							paddingBottom: '90px',
							backdropFilter: 'blur(8px)', // <-- add this line
							WebkitBackdropFilter: 'blur(8px)' // <-- for Safari support
						}}
					>
						<div
							className="popup product-popup-mobile d-md-none"
							style={{
								position: 'relative',
								transform: 'none',
								top: 0,
								left: 0,
								maxWidth: '90%',
								background: '#fff',
								borderRadius: 12,
								boxShadow: 'rgb(0 0 0 / 37%) 0px 0px 20px',
								width: '100%',
								maxHeight: '80dvh',
								padding: '24px 16px 0 16px',
								display: 'flex',
								flexDirection: 'column'
							}}
						>
							<SelectionProvider>
								<ProductList
									selectedItems={selectedRowsData}
									close={handleDoneClick}
									currency={purchaseOrder?.currency}
									handleClose={closePopup}
								/>
								{/* <ProductList
									selectedItems={NULL}
									close={handleDoneClick}
									currency={purchaseOrder?.currency}
									handleClose={closePopup}
								/> */}
							</SelectionProvider>
						</div>
					</div>
				)}
				{showDeleteModal && (
					<DeleteConfirmation
						show={showDeleteModal}
						handleClose={handleClose}
						handleDelete={handleDelete}
						title="Confirm"
						message={`Are you sure you want to remove this product?`}
						customDeleteButtonText={`Yes, Remove product`}
					/>
			)}
			
				{showDeleteAttachment && (
					<DeleteConfirmation
						show={showDeleteAttachment}
						handleClose={handleClose}
						handleDelete={handleDeleteAttachment}
						title="Confirm"
						message={`Are you sure you want to delete attachment?`}
					/>
				)}
			</>
		);
};

export default PurchasingForm;
